/**
 * Estado de la cuenta del comercio (NV-31).
 *
 * El admin suspende con `setAccountStatus` (FN-6): escribe la REFERENCIA `statusProfile/3` en
 * `users/{uid}.status` y en `venue/{uid}.statusProfile`, y deshabilita la cuenta de Auth.
 * Hay documentos legados donde `status` es el string `active`, y `ApisService.getProfile()`
 * entrega `status` ya resuelto al nombre. Por eso el chequeo acepta las tres formas: una
 * referencia (se compara el id del documento), el nombre o el id como string.
 */

/** `PROFILE_STATUS.SUSPENDED` de `@mitter-group/contracts` (`id: '3'`, `name: 'suspended'`). */
export const SUSPENDED_ID = '3';
export const SUSPENDED_NAME = 'suspended';

/** Si un valor de estado (referencia, nombre o id) dice «suspendido». */
export function isSuspendedStatus(value: unknown): boolean {
  if (value === null || value === undefined) {
    return false;
  }
  if (typeof value === 'string') {
    return value === SUSPENDED_NAME || value === SUSPENDED_ID;
  }
  if (typeof value === 'object') {
    const ref = value as { id?: unknown; name?: unknown };
    return ref.id === SUSPENDED_ID || ref.name === SUSPENDED_NAME;
  }
  return false;
}

/**
 * Si el error de Firebase Auth dice que la cuenta fue deshabilitada o que su sesión ya no se
 * puede renovar (los refresh tokens se revocan al suspender). Acepta el error del SDK o el
 * texto con que `ApisService.login()` lo rechaza (`login failed ... (auth/user-disabled)`).
 */
export function isAccountDisabledError(error: unknown): boolean {
  const code = typeof error === 'object' && error !== null ? (error as { code?: unknown }).code : undefined;
  const text = typeof error === 'string' ? error : typeof code === 'string' ? code : `${error}`;
  return text.includes('auth/user-disabled') || text.includes('auth/user-token-expired');
}
